import * as zod from 'zod';

import { DHState } from '@sb/integrations/implementations/dh/comon/types/DHState';

export const DHPGC30060State = DHState.extend({
  kind: zod.literal('DHPGC30060'),
});

export type DHPGC30060State = zod.infer<typeof DHPGC30060State>;
